module.exports = __webpack_public_path__ + "static/media/blog_image_2.7c50ca11.webp";